import loadable from '@loadable/component'

export * from './Overlay'
export const Overlay = loadable(() => import('./Overlay'))
export type { OverlayProps } from './Overlay'
